import styled from 'styled-components';

const StyledCard = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'noPadding',
})`
  padding: ${({ noPadding }) => (noPadding ? '0' : '1.25rem')};
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
`;

export default StyledCard;
